module.exports = __webpack_public_path__ + "static/images/monet/checks_icon.png";